import React from 'react';
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  styled,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export type TClassListOptionsModalOption = {
  key: 'newSection' | 'zoom' | 'resource';
  title: string;
};

interface ClassListOptionsModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (option: TClassListOptionsModalOption) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const OptionCard = ({
  title,
  onClick,
}: {
  title: string;
  onClick: () => void;
}) => {
  return (
    <Card elevation={0} sx={{ border: '1px solid #CBD5E1' }}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography variant="subtitle2" fontWeight={600} textAlign="center">
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const options: Array<TClassListOptionsModalOption> = [
  {
    key: 'newSection',
    title: 'New Section',
  },
  {
    key: 'zoom',
    title: 'Zoom',
  },
  {
    key: 'resource',
    title: 'Resource',
  },
];

const ClassListOptionsModal: React.FC<ClassListOptionsModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  return (
    <BootstrapDialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { minHeight: '300px' } }}
    >
      <DialogTitle>Select an option</DialogTitle>
      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Grid container spacing={2}>
          {options.map((item) => (
            <Grid key={`opt-${item.title}`} item xs={4}>
              <OptionCard {...item} onClick={() => onSubmit(item)} />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: '16px' }}>
        <Button
          size="small"
          variant="contained"
          color="inherit"
          onClick={onClose}
        >
          Dismiss
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ClassListOptionsModal;
